






import { Prop, Component, Vue } from "vue-property-decorator";

@Component({})
export default class VBadgeTo extends Vue {
  @Prop({ default: "secondary" }) variant!: string;
}
